
import { createContext, useContext, useState, ReactNode, useMemo } from 'react';
import { User as UserType } from '@/types/user';

export type UserContextType = {
  user: UserType | null;
  isAnonymousMode: boolean;
  setIsAnonymousMode: (value: boolean) => void;
};

const UserContext = createContext<UserContextType>({
  user: null,
  isAnonymousMode: false,
  setIsAnonymousMode: () => {}
});

export function UserProvider({ children }: { children: ReactNode }) {
  const [user, setUser] = useState<UserType | null>(null);
  const [isAnonymousMode, setIsAnonymousMode] = useState(false);
  
  // Memoize context value to prevent unnecessary rerenders of consuming components
  const contextValue = useMemo(() => ({
    user,
    isAnonymousMode,
    setIsAnonymousMode
  }), [user, isAnonymousMode]);
  
  return (
    <UserContext.Provider value={contextValue}>
      {children}
    </UserContext.Provider>
  );
}

export function useUser() {
  const context = useContext(UserContext);
  if (context === undefined) {
    throw new Error('useUser must be used within a UserProvider');
  }
  return context;
}

// Export for App.tsx
export { UserContext };
